import { updateRegistrationTeasers } from '../registration_teaser'

export default class BookmarkAdd {
  constructor ($el) {
    this.$el = $el
    this.jobId = parseInt(this.$el.data('jobId'))
    this.title = this.$el.data('title')
    this.addEventListeners()
  }

  addEventListeners () {
    this.$el.on('click', ((_this) => {
      return (e) => {
        e.preventDefault()
        _this.add(_this.jobId)
      }
    })(this))
    EventBus.on('bookmarks:add', this.onAdd.bind(this))
  };

  onAdd (_event, jobId) {
    if (this.jobId === jobId) {
      this.add(jobId)
    }
  }

  add (jobId) {
    $.ajax({
      url: this.$el.data().url,
      data: {
        title: this.title,
        refresh_registration_teasers: $('.js-dynamic-registration-teaser').length > 0
      },
      method: 'put',
      dataType: 'json'
    }).done((data) => {
      updateRegistrationTeasers(data.teaser)
      EventBus.trigger('bookmarks:added', jobId)
      EventBus.trigger('snackbar:message', {
        body: data.snackbar,
        handlers: []
      })
    })
  }
}
